__webpack_require__.p = "https://dbshrineayanavaram.org/";